import { render } from "./Surveys.vue?vue&type=template&id=e7c73dd2"
import script from "./Surveys.vue?vue&type=script&lang=js"
export * from "./Surveys.vue?vue&type=script&lang=js"

import "./Surveys.vue?vue&type=style&index=0&id=e7c73dd2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__